"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { usePathname } from "next/navigation";
import { useConsent } from "./ConsentProvider";
import { reportBannerShown } from "./consentOutcome";
import { Button } from "@/components/atoms/button";
import { Link } from "@/components/atoms/Link";
import { ShieldCheck } from "lucide-react";
import { PRIVACY_CHOICES_PATH } from "./privacyChoices";
export function ConsentBanner() {
  const $ = _c(20);
  const pathname = usePathname();
  const {
    marketingConsent,
    analyticsConsent,
    gpcDetected,
    setConsent,
    isLoading
  } = useConsent();
  const isVisible = !isLoading && (marketingConsent === "pending" || analyticsConsent === "pending");
  const onScreen = isVisible && pathname !== "/monitor";
  let t0;
  let t1;
  if ($[0] !== onScreen) {
    t0 = () => {
      if (onScreen) {
        reportBannerShown();
      }
    };
    t1 = [onScreen];
    $[0] = onScreen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  if (!onScreen) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ShieldCheck className="w-6 h-6 text-primary mt-1 shrink-0" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="font-semibold text-lg">Privacy Choices</h2>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-sm text-muted-foreground max-w-2xl">We use cookies and similar technologies to enhance your experience, analyze our traffic, and for security and marketing. You can choose to accept all or reject non-essential processing.{" "}<Link href={PRIVACY_CHOICES_PATH} className="underline underline-offset-2 hover:text-primary">Your Privacy Choices</Link></p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== gpcDetected) {
    t5 = gpcDetected && <p className="text-sm font-semibold text-foreground">Opt-out preference signal honored. Your browser's Global Privacy Control is on, so advertising cookies stay off even if you accept.</p>;
    $[6] = gpcDetected;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="flex items-start gap-3">{t2}<div className="space-y-1">{t3}{t4}{t5}</div></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== setConsent) {
    t7 = <Button variant="outline" onClick={() => setConsent(false, false)} className="whitespace-nowrap">Reject All</Button>;
    $[10] = setConsent;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== setConsent) {
    t8 = <Button onClick={() => setConsent(true, true)} className="whitespace-nowrap">Accept All</Button>;
    $[12] = setConsent;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex items-center gap-3 shrink-0">{t7}{t8}</div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <div role="region" aria-label="Cookie consent" className="fixed bottom-0 left-0 w-full bg-background border-t border-border p-4 shadow-lg z-50 animate-in slide-in-from-bottom-5"><div className="container mx-auto max-w-7xl flex flex-col md:flex-row items-center justify-between gap-4">{t6}{t9}</div></div>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}